import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import proj4 from 'proj4';
import LASParser from "../Parser/LASParser";
import PotreeBinParser from "../Parser/PotreeBinParser";
import Fetcher from "../Provider/Fetcher";
import Source from "./Source";
/**
 * @classdesc
 * An object defining the source of Entwine Point Tile data. It fetches and
 * parses the main configuration file of Entwine Point Tile format,
 * [`ept.json`](https://entwine.io/entwine-point-tile.html#ept-json).
 *
 * @extends Source
 *
 * @property {boolean} isEntwinePointTileSource - Used to checkout whether this
 * source is a EntwinePointTileSource. Default is true. You should not change
 * this, as it is used internally for optimisation.
 * @property {string} url - The URL of the directory containing the whole
 * Entwine Point Tile structure.
 */

var EntwinePointTileSource = /*#__PURE__*/function (_Source) {
  _inherits(EntwinePointTileSource, _Source);

  var _super = _createSuper(EntwinePointTileSource);

  /**
   * @constructor
   *
   * @param {Object} config - The configuration, see {@link Source} for
   * available values.
   * @param {number|string} [config.colorDepth='auto'] - Does the color
   * encoding is known ? Is it `8` or `16` bits ? By default it is to
   * `'auto'`, but it will be more performant if a specific value is set.
   */
  function EntwinePointTileSource(config) {
    var _this;

    _classCallCheck(this, EntwinePointTileSource);

    _this = _super.call(this, config);
    _this.isEntwinePointTileSource = true;
    _this.colorDepth = config.colorDepth; // Necessary because we use the url without the ept.json part as a base

    _this.url = _this.url.replace('/ept.json', ''); // https://entwine.io/entwine-point-tile.html#ept-json

    _this.whenReady = Fetcher.json("".concat(_this.url, "/ept.json"), _this.networkOptions).then(function (metadata) {
      // Set parser and its configuration from schema
      _this.parse = metadata.dataType === 'laszip' ? LASParser.parse : PotreeBinParser.parse;
      _this.extension = metadata.dataType === 'laszip' ? 'laz' : 'bin';

      if (metadata.srs && metadata.srs.authority && metadata.srs.horizontal) {
        _this.crs = "".concat(metadata.srs.authority, ":").concat(metadata.srs.horizontal);

        if (!proj4.defs(_this.crs)) {
          proj4.defs(_this.crs, metadata.srs.wkt);
        }

        if (metadata.srs.vertical && metadata.srs.vertical !== metadata.srs.horizontal) {
          console.warn('EntwinePointTileSource: Vertical coordinates system code is not yet supported.');
        }
      } // NOTE: this spacing is kinda arbitrary here, we take the width and
      // length (height can be ignored), and we divide by the specified
      // span in ept.json. This needs improvements.


      _this.spacing = (Math.abs(metadata.boundsConforming[3] - metadata.boundsConforming[0]) + Math.abs(metadata.boundsConforming[4] - metadata.boundsConforming[1])) / (2 * metadata.span);
      _this.boundsConforming = metadata.boundsConforming;
      _this.span = metadata.span;
      return _assertThisInitialized(_this);
    });
    _this.fetcher = Fetcher.arrayBuffer;
    return _this;
  }

  return _createClass(EntwinePointTileSource);
}(Source);

export default EntwinePointTileSource;